<template>
  <div class="unlock-login">
    <div v-if="!isPhone" class="login-container">
      <div class="login-img">
        <img style="width: 49%" src="@/assets/login/pc_img_logo_forgot_password_paycools.png" alt="">
      </div>
      <div class="login-form-container">
        <!-- 检查邮箱是否正确 -->
        <el-form v-show="active === 'inputEmail'" ref="emailForm" :model="emailForm" class="login-form" auto-complete="on" label-position="top">
          <div class="title-container">
            <h3 class="title">{{ reset ? 'Request Password Reset' : 'Forgot your password?' }}</h3>
            <h4 class="tips mb48">Enter your email address below, and we'll send you a link to reset your password.</h4>
          </div>

          <el-form-item prop="email" label="Email" class="login-form-item mb48" :rules="{ validator: validateEmail, trigger: 'blur' }">
            <el-input
              ref="email"
              v-model="emailForm.email"
              class="login-input"
              placeholder="Email Address"
              name="email"
              type="text"
              tabindex="1"
              auto-complete="on"
              size="default"
            />
            <h4 v-show="isNotRegistered" class="tips red">The email you entered is not registered. Please try again.</h4>
          </el-form-item>
          <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click.native.prevent="sendResetLink">Send Reset Link</el-button>
        </el-form>
        <!-- 检查邮箱是否收到链接 -->
        <div v-show="active === 'checkEmail'" class="login-form">
          <div class="email-img">
            <img src="@/assets/login/email_img.svg" alt="">
          </div>
          <div class="title-container">
            <h3 class="title mt60">Check Your Email</h3>
            <h4 class="tips">We've sent instructions to reset your password.</h4>
          </div>
          <h4 v-if="!exceedance" class="tips">If you don't receive an email within 5 minutes, click below to resend.</h4>
          <h4 v-if="!exceedance" class="tips mt60">Didn't receive an email?
            <span v-if="!isResend" @click="resendEmail">Resend</span>
            <span v-else class="is-resend">Resend in {{ countdownResult }}s</span>
          </h4>
          <h4 v-if="exceedance" class="tips red2">You've reached the resend limit. Please try again in 24 hours.</h4>
          <h4 v-if="exceedance" class="tips">For immediate assistance, contact our customer service.</h4>

        </div>
        <!-- 链接失效 -->
        <div v-show="active === 'checkLink'" class="login-form">
          <div class="link-img">
            <img src="@/assets/login/link_img.svg" alt="">
          </div>
          <div class="title-container mt60">
            <h3 class="title">Reset Link Expired</h3>
            <h4 class="tips mb48">The password reset link you used has expired. Please request a new link to reset your password.</h4>
          </div>

          <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click="requestNewLink">Request New Link</el-button>
        </div>
        <!-- 重置密码 -->
        <el-form v-show="active === 'resetPassword'" ref="resetForm" :model="resetForm" class="login-form" auto-complete="on" label-position="top">
          <div class="title-container">
            <h3 class="title">Reset Your Password</h3>
            <h4 class="tips mb48">Please enter your new password.</h4>
          </div>

          <el-form-item prop="new_password" label="New Password" class="login-form-item form-item-password" :rules="{ validator: checkPasswordLength, trigger: ['blur','change'] }">
            <el-input
              :key="passwordType"
              ref="password"
              v-model="resetForm.new_password"
              class="login-input"
              :type="passwordType?'text':'password'"
              placeholder="New Password"
              name="password"
              tabindex="2"
              auto-complete="on"
              size="default"
              @input="changePassword"
            />
            <span class="show-pwd" @click="showPwd('passwordType','password')">
              <svg-icon :icon-class="!passwordType ? 'eye' : 'eye-open'" />
            </span>
          </el-form-item>

          <el-form-item prop="confirm_password" label="Confirm Password" class="login-form-item" :rules="{ validator: validateConfirmPassword, trigger: ['blur','change'] }">
            <el-input
              :key="passwordType"
              ref="confirmPassword"
              v-model="resetForm.confirm_password"
              class="login-input"
              :type="confirmPasswordType?'text':'password'"
              placeholder="Confirm Password"
              name="confirmPassword"
              tabindex="2"
              auto-complete="on"
              size="default"
              @keyup.enter.native="handleResetPassword"
            />
            <span class="show-pwd" @click="showPwd('confirmPasswordType','confirmPassword')">
              <svg-icon :icon-class="!confirmPasswordType ? 'eye' : 'eye-open'" />
            </span>
          </el-form-item>

          <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click.native.prevent="handleResetPassword">Save New Password</el-button>
        </el-form>
        <!-- 更新成功 -->
        <div v-show="active === 'updatedSuccessfully'" class="login-form">
          <div class="updated-successfully-img">
            <img src="@/assets/login/updated_successfully.svg" alt="">
          </div>
          <div class="title-container mt60">
            <h3 class="title">Password Updated Successfully</h3>
            <h4 class="tips mb48">Your password has been reset. You can now log in with your new password.</h4>
          </div>
          <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click="goLogin">Go to Login</el-button>
        </div>
        <!-- <p v-if="$store.getters.isPii" class="version-text">© {{ new Date().getFullYear() }} PayCools (Payment Innovations Inc.)</p> -->
      </div>

    </div>
    <div v-if="isPhone" class="xs-login-container">
      <!-- 检查邮箱是否正确 -->
      <el-form v-show="active === 'inputEmail'" ref="emailForm" :model="emailForm" class="xs-login-form" auto-complete="on" label-position="top">
        <div class="title-container">
          <h3 class="title">{{ reset ? 'Request Password Reset' : 'Forgot your password?' }}</h3>
          <h4 class="tips mb48">Enter your email address below, and we'll send you a link to reset your password.</h4>
        </div>

        <el-form-item prop="email" label="Email" class="login-form-item mb48" :rules="{ validator: validateEmail, trigger: 'blur' }">
          <el-input
            ref="email"
            v-model="emailForm.email"
            class="login-input"
            placeholder="Email Address"
            name="email"
            type="text"
            tabindex="1"
            auto-complete="on"
            size="default"
          />
          <h4 v-show="isNotRegistered" class="tips red">The email you entered is not registered. Please try again.</h4>
        </el-form-item>
        <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click.native.prevent="sendResetLink">Send Reset Link</el-button>
      </el-form>
      <!-- 检查邮箱是否收到链接 -->
      <div v-show="active === 'checkEmail'" class="xs-login-form">
        <div class="email-img">
          <img src="@/assets/login/email_img.svg" alt="">
        </div>
        <div class="title-container">
          <h3 class="title mt60">Check Your Email</h3>
          <h4 class="tips">We've sent instructions to reset your password.</h4>
        </div>
        <h4 v-if="!exceedance" class="tips">If you don't receive an email within 5 minutes, click below to resend.</h4>
        <h4 v-if="!exceedance" class="tips mt60">Didn't receive an email?
          <span v-if="!isResend" @click="resendEmail">Resend</span>
          <span v-else class="is-resend">Resend in {{ countdownResult }}s</span>
        </h4>
        <h4 v-if="exceedance" class="tips red2">You've reached the resend limit. Please try again in 24 hours.</h4>
        <h4 v-if="exceedance" class="tips">For immediate assistance, contact our customer service.</h4>

      </div>
      <!-- 链接失效 -->
      <div v-show="active === 'checkLink'" class="xs-login-form">
        <div class="link-img">
          <img src="@/assets/login/link_img.svg" alt="">
        </div>
        <div class="title-container mt60">
          <h3 class="title">Reset Link Expired</h3>
          <h4 class="tips mb48">The password reset link you used has expired. Please request a new link to reset your password.</h4>
        </div>

        <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click="requestNewLink">Request New Link</el-button>
      </div>
      <!-- 重置密码 -->
      <el-form v-show="active === 'resetPassword'" ref="resetForm" :model="resetForm" class="xs-login-form" auto-complete="on" label-position="top">
        <div class="title-container">
          <h3 class="title">Reset Your Password</h3>
          <h4 class="tips mb48">Please enter your new password.</h4>
        </div>

        <el-form-item prop="new_password" label="New Password" class="login-form-item form-item-password" :rules="{ validator: checkPasswordLength, trigger: ['blur','change'] }">
          <el-input
            :key="passwordType"
            ref="password"
            v-model="resetForm.new_password"
            class="login-input"
            :type="passwordType?'text':'password'"
            placeholder="New Password"
            name="password"
            tabindex="2"
            auto-complete="on"
            size="default"
            @input="changePassword"
          />
          <span class="show-pwd" @click="showPwd('passwordType','password')">
            <svg-icon :icon-class="!passwordType ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>

        <el-form-item prop="confirm_password" label="Confirm Password" class="login-form-item" :rules="{ validator: validateConfirmPassword, trigger: ['blur','change'] }">
          <el-input
            :key="passwordType"
            ref="confirmPassword"
            v-model="resetForm.confirm_password"
            class="login-input"
            :type="confirmPasswordType?'text':'password'"
            placeholder="Confirm Password"
            name="confirmPassword"
            tabindex="2"
            auto-complete="on"
            size="default"
            @keyup.enter.native="handleResetPassword"
          />
          <span class="show-pwd" @click="showPwd('confirmPasswordType','confirmPassword')">
            <svg-icon :icon-class="!confirmPasswordType ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>

        <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click.native.prevent="handleResetPassword">Save New Password</el-button>
      </el-form>
      <!-- 更新成功 -->
      <div v-show="active === 'updatedSuccessfully'" class="xs-login-form">
        <div class="updated-successfully-img">
          <img src="@/assets/login/updated_successfully.svg" alt="">
        </div>
        <div class="title-container mt60">
          <h3 class="title">Password Updated Successfully</h3>
          <h4 class="tips mb48">Your password has been reset. You can now log in with your new password.</h4>
        </div>
        <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click="goLogin">Go to Login</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { sendResetPwdEmail, resetPwd, isExpired } from '@/api/user'
import { cryptoJSAesEncrypt } from '@/utils/encrypt'

export default {
  name: 'ForgotPassword',
  components: { },
  data() {
    this.validateEmail = (rule, value, callback) => {
      if (!value || value.length <= 0) {
        return callback(new Error('Please enter the email'))
      }
      return callback()
    }
    this.checkPasswordLength = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Passwords cannot be empty'))
      }
      if (value && (value.length < 8 || value.length > 15)) {
        return callback(new Error('Passwords must between 8 ~ 15 character'))
      }
      const regex = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@%*&_])[A-Za-z\\d@%*&_]{8,15}$')
      if (!regex.test(value)) {
        return callback(new Error('New Password must be between 8 and 15 characters. Must contain and only contain the following: uppercase and lowercase letters, alphabets, and special characters (limited to @%*&_).'))
      }

      return callback()
    }
    this.validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Confirm Password cannot be empty'))
      }
      if (!value || this.resetForm.confirm_password !== this.resetForm.new_password) {
        return callback(new Error('The passwords entered twice are inconsistent'))
      }
      return callback()
    }
    return {
      active: 'inputEmail', // inputEmail  resetPassword updatedSuccessfully
      isResend: false,
      isNotRegistered: false,
      exceedance: false,
      reset: false,
      resetForm: {
        new_password: '',
        confirm_password: ''
      },
      emailForm: {
        email: ''
      },
      loading: false,
      passwordType: false,
      confirmPasswordType: false,
      isPhone: false,
      countdownTimer: null,
      countdownResult: '',
      token: ''
    }
  },
  created() {
    this.changePage()
    this.checkIsExpired()
  },
  mounted() {
    window.onresize = () => {
      this.changePage()
    }
  },
  beforeDestroy() {
    window.onresize = null
    this.initCountdown()
  },
  methods: {
    checkIsExpired() {
      if (this.$route.query.token) {
        isExpired({ token: this.$route.query.token }).then(res => {
          if (res.code === 10000 && res.data === true) {
            this.token = this.$route.query.token
            this.active = 'resetPassword'
          } else {
            this.active = 'checkLink'
            this.reset = true
          }
        })
      }
    },
    changePage() {
      const screenWidth = document.documentElement.clientWidth
      if (screenWidth <= 768) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    showPwd(type, ref) {
      this[type] = !this[type]
      this.$nextTick(() => {
        this.$refs[ref].focus()
      })
    },
    sendResetLink(type) {
      if (this.loading) return
      this.$refs.emailForm.validate((valid) => {
        if (valid) {
          const params = {
            username: cryptoJSAesEncrypt(this.emailForm.email)
          }
          if (this.$store.getters.isEz || this.$store.getters.isAruxpay) {
            params.mch_counterparty = cryptoJSAesEncrypt('unlock')
          } else {
            params.mch_counterparty = cryptoJSAesEncrypt('paycools')
          }
          this.loading = true
          sendResetPwdEmail(params).then(res => {
            if (res.code === 10000) {
              if (type === 'resend') {
                this.initCountdown()
              }
              const failCode = res.data?.fail_code
              switch (failCode) {
                // 未注册的邮箱
                case 20013:
                  this.isNotRegistered = true
                  break
                  // 超过次数限制
                case 20014:
                  this.active = 'checkEmail'
                  this.exceedance = true
                  break
                  // 成功发送邮件
                default:
                  this.active = 'checkEmail'
                  break
              }
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    resendEmail() {
      this.sendResetLink('resend')
    },
    clearTimer(timer) {
      if (timer !== null) {
        clearInterval(timer)
        timer = null
      }
    },
    initCountdown() {
      this.isResend = true
      this.countdownResult = 120
      this.countdownTimer = setInterval(() => {
        if (this.countdownResult > 1) {
          this.countdownResult--
        } else {
          this.clearTimer(this.countdownTimer)
          this.isResend = false
        }
      }, 1000)
    },
    requestNewLink() {
      this.active = 'inputEmail'
    },
    handleResetPassword() {
      this.$refs.resetForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const params = {
            new_password: cryptoJSAesEncrypt(this.resetForm.new_password),
            confirm_password: cryptoJSAesEncrypt(this.resetForm.confirm_password),
            token: this.token
          }
          if (this.$store.getters.isEz || this.$store.getters.isAruxpay) {
            params.mch_counterparty = cryptoJSAesEncrypt('unlock')
          } else {
            params.mch_counterparty = cryptoJSAesEncrypt('paycools')
          }
          resetPwd(params).then(res => {
            if (res.code === 10000 && res.data?.fail_code !== 20015) {
              this.active = 'updatedSuccessfully'
            } else {
              this.active = 'checkLink'
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    goLogin() {
      this.resetForm = {}
      this.emailForm = {}
      this.$router.push('/login')
      this.active = 'inputEmail'
    },
    changePassword() {
      if (this.resetForm.confirm_password) {
        this.$refs.resetForm.validate()
      }
    }
  }
}
</script>
<style>
.unlock-login  input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #fff inset !important;
   -webkit-text-fill-color: #4B5567 !important;
}
.unlock-login .login-input .el-input__inner{
  height: 42px;
  border: 1px solid #D2D8E3;
  font-size: 16px;
  border-radius: 8px;
}
.unlock-login .login-form-item .el-form-item__label{
  font-size: 18px;
}
.unlock-login .xs-login-container .google-login-verify{
  /* width: 250px; */
  overflow-y: hidden;
  overflow-x: auto;
}

@media screen and (max-width: 1441px) {
  .unlock-login .login-form-item .el-form-item__label{
    font-size: 16px;
  }
  .unlock-login .login-input .el-input__inner{
    height: 38px;
    font-size: 13px;
  }
}
</style>

<style lang="scss" scoped>
.unlock-login{
  height: 100vh;
}
.tips{
  color: rgba(54, 60, 74, 0.50);
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 20px;
  font-weight: 500;
  &.red{
    color: #991B1B;
    margin-bottom: 0;
  }
  &.red2{
    color: #991B1B;
    margin: 48px 0;
  }
  span{
    color: #3855F1;
    font-weight: 700;
    cursor: pointer;
    &.is-resend{
      color: rgba(56, 85, 241, 0.50);
      cursor: not-allowed;
    }
  }
}
.mt60{
  margin-top: 60px;
}
.mb48{
  margin-bottom: 48px;
}
.login-container {
  height: 100vh;
  width: 100%;
  // background: #FFFFFF;
  overflow: hidden;
  display: flex;
  .login-img{
    // padding-top: 60px;
    width: 50%;
    // min-height: 650px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background: linear-gradient(98.94deg, #349EFF 0%, #306EDE 50.7%, #0124D9 100%);
    box-shadow: inset 0px 4px 20px rgba(0, 0, 0, 0.1), inset 0px 4px 10px rgba(0, 0, 0, 0.25);
    &::before{
      content: '';
      position: absolute;
      top: -12.5vw;
      left: -12.5vw;
      transform: rotate(-45deg);
      width: 25vw;
      height: 25vw;
      background: linear-gradient(-45deg, rgba(255, 255, 255, .15) 0, rgba(255, 255, 255, 0) 50%);
    }
    &::after{
      content: '';
      position: absolute;
      bottom:-12.5vw;
      right: -12.5vw;
      transform: rotate(-45deg);
      width: 25vw;
      height: 25vw;
      background: linear-gradient(-45deg, rgba(255, 255, 255, .15) 0, rgba(255, 255, 255, 0) 100%);
    }
     .login-img-content{
       width: 80%;
     }
  }
  .login-form-container{
    position: relative;
    height: 100vh;
    // min-height: 650px;
    flex: 1;
    display: flex;
    justify-content:center;
    align-items: center;
  }

  .login-form {
    width: 80%;
    max-width: 520px;
    background: #FFFFFF;
    .updated-successfully-img{
      display: flex;
      justify-content: center;
    }
  }
  .title{
    color: #1D3A71;
    font-size: 28px;
    margin-bottom: 16px;
  }
  .version-text{
    position: absolute;
    bottom: 25px;
    font-weight: 400;
    font-size: 12px;
    color: #98A1B4;;
  }
}

</style>

<style lang="scss" scoped>

.xs-login-container{
  position: relative;
  padding: 0 36px;
  height: 100vh;
  display: flex;
  justify-content:center;
  align-items: center;
  overflow: hidden;
  height: 100vh;
  width: 100%;
  background: linear-gradient(167.94deg, #142D5A 0%, #1E3885 26.68%, #2742A9 64.82%, #3855F1 100%);
  overflow: hidden;
  &::before{
    content: '';
    position: absolute;
    top:-100px;
    left: -200px;
    transform: rotate(-45deg);
    width: 400px;
    height: 200px;
    background: linear-gradient(180deg, rgba(255, 255, 255, .1) 0, rgba(255, 255, 255, .05) 100%);
  }
  &::after{
    content: '';
    position: absolute;
    bottom:-100px;
    right: -200px;
    transform: rotate(-45deg);
    width: 400px;
    height: 200px;
    background: linear-gradient(180deg, rgba(255, 255, 255, .1) 0, rgba(255, 255, 255, .05) 100%);
  }
}

.xs-login-form {
  box-sizing: border-box;
  padding: 59px 32px;
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 5px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  .updated-successfully-img{
    display: flex;
    justify-content: center;
  }
}
.form-item-password{
  margin-bottom: 30px;
}
.show-pwd{
  position: absolute;
  right: 13px;
  top: 3px;
  cursor: pointer;
}
.xs-title{
  margin:0;
  font-weight: 700;  font-family: 'Inter-Bold';
  font-size: 16px;
  line-height: 22px;
  color: #1D3A71;
}
.xs-version-text{
  position: absolute;
  bottom: 25px;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
}

@media screen and (max-width: 1441px) {
 .login-container{
  .title{
      font-size: 22px;
    }
  .login-form {
    width: 60%;
    background: #FFFFFF;
  }
  .show-pwd{
    top: 1px;
  }
 }

}
</style>
